import {type StyleProp, type ViewStyle} from 'react-native'
import Svg, {Path, Rect} from 'react-native-svg'

export type MenuNotificationsSvgProps = {
  size: number
  style?: StyleProp<ViewStyle>
  active?: boolean
  activeColor?: string
  inactiveColor?: string
}

export default function MenuNotificationsSvg(props: MenuNotificationsSvgProps) {
  const {
    size,
    style,
    active,
    activeColor = '#1083FE',
    inactiveColor = '#6F869F',
  } = props
  return (
    <Svg
      fill={'none'}
      viewBox="0 0 40 40"
      width={size}
      height={size}
      style={[style]}>
      {active ? (
        <Path
          d="M19.9997 0.75C21.0121 0.75 21.8335 1.57064 21.8337 2.58301V3.61426C29.0684 4.51663 34.6667 10.6878 34.6667 18.167V29.167H36.4997C37.5122 29.167 38.3337 29.9875 38.3337 31C38.3337 32.0125 37.5122 32.833 36.4997 32.833H26.4167L26.4079 33.1631C26.2363 36.5537 23.4329 39.25 19.9997 39.25C16.5666 39.2498 13.7631 36.5536 13.5915 33.1631L13.5837 32.833H3.49969C2.48731 32.8328 1.66669 32.0124 1.66669 31C1.66669 29.9876 2.48731 29.1672 3.49969 29.167H5.33368V18.167C5.33368 10.6877 10.9318 4.51544 18.1667 3.61328V2.58301C18.1669 1.57074 18.9874 0.750166 19.9997 0.75ZM17.2497 32.833C17.2497 34.3517 18.4811 35.5828 19.9997 35.583C21.5185 35.583 22.7497 34.3518 22.7497 32.833H17.2497Z"
          fill="#0B0F14"
        />
      ) : (
        <Path
          d="M19.9997 0.75C21.0121 0.75 21.8335 1.57064 21.8337 2.58301V3.61426C29.0684 4.51663 34.6667 10.6878 34.6667 18.167V29.167H36.4997C37.5122 29.167 38.3337 29.9875 38.3337 31C38.3337 32.0125 37.5122 32.833 36.4997 32.833H26.4167L26.4079 33.1631C26.2363 36.5537 23.4329 39.25 19.9997 39.25C16.5666 39.2498 13.7631 36.5536 13.5915 33.1631L13.5837 32.833H3.49969C2.48731 32.8328 1.66669 32.0124 1.66669 31C1.66669 29.9876 2.48731 29.1672 3.49969 29.167H5.33368V18.167C5.33368 10.6877 10.9318 4.51544 18.1667 3.61328V2.58301C18.1669 1.57074 18.9874 0.750166 19.9997 0.75ZM17.2497 32.833C17.2497 34.3517 18.4811 35.5828 19.9997 35.583C21.5185 35.583 22.7497 34.3518 22.7497 32.833H17.2497ZM19.9997 7.16699C13.9247 7.16716 8.99969 12.092 8.99969 18.167V29.167H30.9997V18.167C30.9997 12.0919 26.0748 7.16699 19.9997 7.16699Z"
          fill="#0B0F14"
        />
      )}
    </Svg>
  )
}
